import { BrandRecommendApi } from "./brand-recommend-api";
import { BrandRecommendHandler } from "./brand-recommend-handler";
import { BrandRecommendListener } from "./brand-recommend-listener";
import { BrandRecommendRender } from "./brand-recommend-render";

export class BrandRecommendSetup {
    public static init(): void {
        if (document.documentElement.dataset.brandRecommendInit === "1") return;
        document.documentElement.dataset.brandRecommendInit = "1";

        const render = new BrandRecommendRender();
        const handler = new BrandRecommendHandler({ api: BrandRecommendApi, render });
        const listener = new BrandRecommendListener({ handler });
        listener.register();
    }
}

export function initBrandRecommendSystem(): void {
    BrandRecommendSetup.init();
}
